import { apiFetch, setAccessToken } from '@/shared/api';
import { authResponseSchema, authUserSchema } from '../model/types';
import type { AuthResponse, AuthUser, Credentials, RegistrationDetails } from '../model/types';

async function post(path: string, body?: unknown): Promise<AuthResponse> {
  const raw = await apiFetch<unknown>(path, {
    method: 'POST',
    body: body === undefined ? undefined : JSON.stringify(body),
    skipRetry: true,
  });

  const parsed = authResponseSchema.parse(raw);
  setAccessToken(parsed.accessToken);
  return parsed;
}

export const authApi = {
  login: (credentials: Credentials) => post('/api/auth/login', credentials),

  register: (details: RegistrationDetails) => post('/api/auth/register', details),

  /** Restores a session from the refresh cookie. Returns null when there is none. */
  restore: async (): Promise<AuthResponse | null> => {
    try {
      return await post('/api/auth/refresh');
    } catch {
      setAccessToken(null);
      return null;
    }
  },

  logout: async () => {
    try {
      await apiFetch<void>('/api/auth/logout', { method: 'POST', skipRetry: true });
    } finally {
      setAccessToken(null);
    }
  },

  me: async (): Promise<AuthUser> => authUserSchema.parse(await apiFetch<unknown>('/api/auth/me')),
};
